import styled from "styled-components";

export const CreateRoleBtn = styled.button`
    background: ${(props) => props.theme.colors.button.primary};
    box-shadow: 0px 54px 29px rgba(0, 0, 0, 0.02), 0px 27.0264px 14.5142px rgba(0, 0, 0, 0.0152067), 0px 16.2794px 8.74265px rgba(0, 0, 0, 0.0130318), 0px 10.4327px 5.60275px rgba(0, 0, 0, 0.0114179), 0px 6.76164px 3.63125px rgba(0, 0, 0, 0.01), 0px 4.25637px 2.28583px rgba(0, 0, 0, 0.0085821), 0px 2.44555px 1.31335px rgba(0, 0, 0, 0.00696822), 0px 1.07635px 0.57804px rgba(0, 0, 0, 0.00479335);
    border-radius: 40px;
    border: 0px !important;
    font-family: ${(props) => props.theme.fonts[0]};
    font-style: normal;
    font-weight: ${(props) => props.theme.fontWeights.normal};
    font-size: ${(props) => props.theme.fontSizes.h5};
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: ${(props) => props.theme.colors.text.penta};
    width: 100%;
    height: 51px;
    cursor: pointer;
    outline: none !important;
    &:focus-visible {
        border: 3px solid grey !important;
       }
`